// extracted by mini-css-extract-plugin
module.exports =  {"warehouseOverview":"warehouseOverview__W1jU4","active":"active__2U8ai","info":"info__ErTqy","loader":"loader__HiUB-"};